@if (!isDestroyed) {
    <div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100">
        @if (!Spinner.isShown('initial')) {
            <form [formGroup]="form" class="mt-24 min-max-w-400">
                @if (form.controls.dictionaryType) {
                    <af-dictionary-selector
                        dictionaryName="reference"
                        class="min-max-w-400"
                        fxFlex
                        [control]="form.controls.dictionaryType"
                        placeholder="i18n_af_placeholderDictionaryType"/>
                }
            </form>
        }
        <af-full-table class="w-100 h-100"
                       [showFilter]="false"
                       [showPaginator]="false"
                       [dataSource]="dataSource"
                       additionalSpinnerIds="reference"
                       [addTableTranslationPrefix]="false"
                       emptyStateIconName="ic_empty_state_no_data"
                       emptyStateTitleTranslationKey="i18n_af_emptyStateTitleNoData"
                       emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleDictionaryNoData"/>
    </div>
}
